import React, {useState, useEffect, useCallback} from "react";
import {
    selfcareChangeContactPermissions,
    selfcareContactPermissions,
    selfcareCustomerAcceptedPermissionText,
    selfcareLatestPermissionText
} from "../../../util/request";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import LoaderSpinner from "../../loaders/LoaderSpinner";

export default function ChangeContactPermissions(props: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    permissions: { [index: string]: any },
    setPermissions: (v: object) => void,
    permission_text_accepted: string,
}) {
    const {customer} = useCustomer()
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [successMessage, setSuccessMessage] = useState<string | null>(null)
    const [showAcceptMarketingPermissions, setShowAcceptMarketingPermissions] = useState<boolean>(false);
    const [permission_text_accepted, setPermissionTextAccepted] = useState<string>(props.permission_text_accepted)

    const NoThanksClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setShowAcceptMarketingPermissions(false);
    }

    const CheckIfNeedToShowAcceptMarketingPermissionsPopup = (event: React.MouseEvent<HTMLInputElement>):void => {
        event.preventDefault();
        let showPopup :boolean = false;
        selfcareContactPermissions(customer.customer_id).then((r) => {
            Object.keys(props.permissions)
                .sort((a, b) => a.localeCompare(b))
                .map((keyName) => {
                    if (keyName.startsWith('contact_permission_Marketing_') && props.permissions[keyName].is_action_set === true && r.response.data[keyName].is_action_set === false) {
                        showPopup = true;
                    }
                    return keyName;
                });

            if (showPopup) {
                selfcareLatestPermissionText(customer.customer_id).then( (r) => {
                    if ( r.response.data != permission_text_accepted){
                        setShowAcceptMarketingPermissions(true);
                    } else {
                        doSubmit();
                    }
                });
            } else {
                doSubmit();
            }
        });
    }

    const AcceptMarketingPermissionsPopup = () => {
        const [permissionText, setPermissionText] = useState<string>('');

        const fetchPermissionText = useCallback(() => {
            selfcareLatestPermissionText(customer.customer_id)
                .then((response) => {
                    setPermissionText(response.response.data);
                })
        }, [])

        useEffect(() => {
            fetchPermissionText();
        }, [fetchPermissionText]);

        return <>
            <div className={'selfcare-popup-overlay'} onClick={() => setShowAcceptMarketingPermissions(false)}></div>
            <div className={'selfcare-popup selfcare-popup--change-contact-permissions'}>
                <button className={'close-popup wl-overlay__close'}>&times;</button>
                <h3 className={'heading--montserrat heading--left'}>
                    Giv os lov til at kontakte dig
                </h3>
                <p className="small" dangerouslySetInnerHTML={{__html: permissionText}}></p>
                <div className={'buttons'}>
                    <button className={'cancel'} onClick={NoThanksClick}>Nej tak</button>
                    <button className={'confirm'} type="submit">Ja tak!</button>
                </div>
            </div>
        </>
    }

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        doSubmit();
    }

    const doSubmit = () => {
        setShowAcceptMarketingPermissions(false);

        setLoading(true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedPermissions: any[] = [];

        for (const propName in props.permissions) {
            updatedPermissions.push(
                {
                    "key": propName,
                    "permission_type_id": props.permissions[propName].permission_type_id,
                    "is_action_set": props.permissions[propName].is_action_set,
                    "communication_channel_id": 1, // 1 = selfcare
                }
            );
        }

        selfcareChangeContactPermissions(customer.customer_id, updatedPermissions).then(r => {
            if (r.code !== 200) {
                setErrorMessage(r.response.error_message as string)
                return
            }

            for (const propName in props.permissions) {
                props.permissions[propName].state[1](r.response.data[propName].is_action_set)
            }

            selfcareCustomerAcceptedPermissionText(customer.customer_id).then( (r) => {
                setPermissionTextAccepted( r.response.data );
            });

            setSuccessMessage('De nye tilladelser er gemt')
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <>
            <form className="selfcare-account-form visible" onSubmit={handleFormSubmit}>
                {<>
                    {Object.keys(props.permissions)
                        .sort((a, b) => a.localeCompare(b))
                        .map((keyName, index) => {
                            return (
                                <p key={index} className="checkbox">
                                    <input
                                        className=""
                                        type="checkbox"
                                        id={"permission_" + props.permissions[keyName].permission_type_id}
                                        checked={props.permissions[keyName].is_action_set}
                                        onChange={() => {
                                            props.permissions[keyName].is_action_set = !props.permissions[keyName].is_action_set
                                            props.permissions[keyName].state[1](props.permissions[keyName].is_action_set)
                                        }}
                                    />
                                    <label
                                        htmlFor={"permission_" + props.permissions[keyName].permission_type_id}
                                        className="checkbox-label checkbox-label--montserrat"
                                    >{props.permissions[keyName].permission_type_name}</label>
                                </p>
                            )
                        })}

                    {errorMessage && <p className="selfcare-message-error">{errorMessage}</p>}

                    <p className={'smaller'} dangerouslySetInnerHTML={{__html: permission_text_accepted}}></p>

                    {loading ? <LoaderSpinner/> :
                        <p className="submit-button-block">
                            <label id="submit-form-button" className="button teal">
                                <input
                                    disabled={loading}
                                    className="continue-button-submit"
                                    onClick={CheckIfNeedToShowAcceptMarketingPermissionsPopup}
                                />
                                <span className="text">Gem</span>
                            </label>
                        </p>
                    }
                </>
                }
                {successMessage && <p className="selfcare-message-success">{successMessage}</p>}
                {showAcceptMarketingPermissions && <AcceptMarketingPermissionsPopup/>}
            </form>
        </>

    )

}
